module.exports = "/assets/data/5a65210e40d43bd3a7de2f8b1fc0aed0-G73.data.json";